<div>
  <p>Redirecting to login...</p>
</div>
